import React from 'react';
import { addMonths } from 'date-fns';

import { Box, Paragraph, Text } from '@zillow/constellation-10';

import { coerceToDate } from '@common/paymentsUtils/dateUtils';
import { formatDate } from '@common/paymentsUtils/dateUtils';
import type { RenterPaymentMethodInterface } from '@renter-hub/models/Types';
import TotalPaymentModule from '@renter-hub/components/TotalPaymentModule';
import { SelectedPaymentMethod } from '@renter-hub/components/SelectedPaymentMethod';
import { centsToDollars } from '@common/paymentsUtils/currencyUtils';

interface Props {
  selectedDate: string;
  numberOfPayments: number;
  monthToMonth: boolean;
  dueDate?: string;
  totalAmount?: number;
  fee?: number;
  dueAmount: number;
  paymentMethod?: RenterPaymentMethodInterface;
}

const RecurringConfirmationPage = (props: Props) => {
  const { selectedDate, numberOfPayments, totalAmount, dueAmount, fee, monthToMonth, paymentMethod } = props;
  const lastPaymentDate = addMonths(coerceToDate(selectedDate)!, numberOfPayments - 1);

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'token(spacing.sm)' }}>
      <Paragraph>We’ll email you a reminder 5 days before your payment is due each month.</Paragraph>
      <Box css={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 'token(spacing.md)' }}>
        <Box>
          <Paragraph textStyle="body-bold">First send date</Paragraph>
          <Text>{formatDate(selectedDate, 'MMM d, yyyy')}</Text>
        </Box>
        <Box>
          <Paragraph textStyle="body-bold">Last send date</Paragraph>
          <Text>{monthToMonth ? 'Month-to-month' : formatDate(lastPaymentDate, 'MMM d, yyyy')}</Text>
        </Box>
        <Box>
          {totalAmount ? (
            <TotalPaymentModule feeAmount={fee} totalAmount={totalAmount} heading="Rent amount" />
          ) : (
            <>
              <Paragraph textStyle="body-bold">Rent amount</Paragraph>
              <Text>{centsToDollars(dueAmount)}</Text>
            </>
          )}
        </Box>
        <Box>
          {paymentMethod && (
            <SelectedPaymentMethod
              displayName={paymentMethod.displayName}
              nickname={paymentMethod.nickname}
              accountLast4={paymentMethod.accountLast4}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default RecurringConfirmationPage;
